import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';


@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggler.component.html',
    styleUrls: ['./slide-toggler.component.scss']
})
export class SlideTogglerComponent implements OnInit, OnChanges {

    @Input()
    status: boolean = false;

    @Output()
    changed = new EventEmitter<boolean>();

    @Input()
    allowLight: boolean = false;

    constructor() { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.current) {
            this.status = changes.current.currentValue;
        }
    }

    ngOnInit(): void {

    }

    toggle() {
        // this.status = !this.status
        this.changed.emit(this.status);
    }

}
